import React from 'react'
import PropTypes from 'prop-types'
import { CRUDShow } from '../CRUD'

const ServicoShow = (props) => {
  if (props.servico) {
    return (
      <CRUDShow
        title={props.servico.nome}
        icon='wrench'
        onEditResource={() => props.onEditResource(props.servico.id)}
        onDeleteResource={() => props.onDeleteResource(props.servico.id)}>
        <ul>
          <li>Nome: {props.servico.nome}</li>
          <li>Descrição: {props.servico.descricao}</li>
        </ul>
      </CRUDShow>
    )
  }

  return (null)
}

ServicoShow.propTypes = {
  servico: PropTypes.object,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
}

export default ServicoShow
